import script from "./BrandPromotion.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandPromotion.vue?vue&type=script&setup=true&lang=js"

import "./BrandPromotion.vue?vue&type=style&index=0&id=263b8f20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-263b8f20"]])

export default __exports__